// Tiny shared store for things the header should show a badge for
// (unread friend messages and pending friend requests).
import {useEffect, useState} from "react";

let state = {unreadByFriend: {}, friendRequests: 0};
const listeners = new Set();

const emit = () => listeners.forEach((listener) => listener(state));

export const addUnread = (friendName) => {
    state = {...state, unreadByFriend: {...state.unreadByFriend, [friendName]: (state.unreadByFriend[friendName] || 0) + 1}};
    emit();
};

export const clearUnread = (friendName) => {
    if (!state.unreadByFriend[friendName]) return;
    const next = {...state.unreadByFriend};
    delete next[friendName];
    state = {...state, unreadByFriend: next};
    emit();
};

export const setFriendRequestCount = (count) => {
    state = {...state, friendRequests: count};
    emit();
};

export const useNotifications = () => {
    const [value, setValue] = useState(state);
    useEffect(() => {
        listeners.add(setValue);
        setValue(state);
        return () => listeners.delete(setValue);
    }, []);
    const unreadTotal = Object.values(value.unreadByFriend).reduce((sum, n) => sum + n, 0);
    return {...value, unreadTotal};
};
